import { AuthService } from "./services/AuthService";

if (!window["WidgetLoaded"]) {
    window["WidgetLoaded"] = true;

    require("./css/widget.css");
    require("./polyfills/element-closest.js");
    require("./polyfills/hashchange.js");
    require("./polyfills/array-find.js");

    var loadingHtml = require("./templates/loading.html") as string;
    var messageHtml = (require("./templates/message.html") as string).replace(/{{.*?}}/gm, "");

    var browserNotSupported = typeof FormData === "undefined";
    var widgetHtmlLoaded = false;

    var showMessage = (element: Element, messageHtml: string, messageContent: string) => {
        element.innerHTML = messageHtml;
        element.getElementsByClassName("pl-hd-widget-message-view-content")
            .item(0)
            .innerHTML = messageContent;
        const message = element.getElementsByClassName("pl-hd-widget-message-view").item(0) as HTMLElement;
        message.style.display = "block";
    }

    var initializer = () => {
        var elements = document.getElementsByClassName("pl-hd-widget");
        widgetHtmlLoaded = elements.length > 0;
        for (let i = 0; i < elements.length; ++i) {
            const element = elements[i] as HTMLElement;
            if (browserNotSupported) {
                showMessage(element, messageHtml, "Your browser is not supported.");
            } else {
                element.innerHTML = loadingHtml;
            }
        }
    };

    var styler = () => {
        var elements = document.getElementsByClassName("pl-hd-widget");
        for (let i = 0; i < elements.length; ++i) {
            const element = elements[i] as HTMLElement;
            let container = element.closest("[webpartid]") as HTMLElement;
            if (!container) {
                container = element.parentElement;
            }
            if (container.offsetWidth < 320) {
                container.style.width = "320px";
            }
            if (container.offsetHeight < 200) {
                container.style.height = "200px";
            }
            container.style.overflowX = "hidden";
        }
    };

    var domLoadedInterval = setInterval(() => {
            if (document.readyState === "complete") {
                clearInterval(domLoadedInterval);
                if (!widgetHtmlLoaded) {
                    initializer();
                }
                styler();
            }
        },
        50);

    initializer();

    if (browserNotSupported) {
        throw new Error("Browser is not supported");
    }

    require([
        "knockout",
        "jquery",
        "./components",
        "knockout.validation",
        "knockout-punches",
        "./services/ConfigService",
        "./services/AuthService",
        "./services/LocalizationService"
    ],
        async (
            ko: KnockoutStatic,
            $: JQueryStatic,
            components: {
                registerComponents: Function;
            }) => {

            require("style!./css/fabric.min.css");
            require("style!./css/fabric.components.min.css");

            var loginViewModel = require("./viewmodels/LoginViewModel");
            var appviewmodel = require("./viewmodels/AppViewModel");
            var servicesAuthservice = require("./services/AuthService");
            var servicesConfigservice = require("./services/ConfigService");
            var servicesLocalizationservice = require("./services/LocalizationService");

            $(document).ready(async () => {
                ko.punches.enableAll();
                ko.validation.init({
                    errorMessageClass: "pl-hd-widget-has-error ms-font-m",
                    errorElementClass: "pl-hd-widget-has-error",
                    decorateInputElement: true,
                    insertMessages: true,
                    parseInputAttributes: true,
                    messagesOnModified: true,
                    decorateElementOnModified: true
                },
                    true);

                components.registerComponents();

                $(".pl-hd-widget").each((async (index: number, element: Element) => {
                    var configService = new servicesConfigservice.ConfigService(element);
                    await configService.Init();
                    var authService = new servicesAuthservice.AuthService(configService);
                    var localizationService = new servicesLocalizationservice.LocalizationService(configService);


                    var appBootstrapper = () => {
                        const appViewModel =
                            new appviewmodel.AppViewModel(element, authService, configService, localizationService);
                        appViewModel.Init();
                    }

                    if (AuthService.isOnSPSite) {
                    try {
                        await authService.SPAuthenticate();
                        console.info("SharePoint authentication succeeded");
                        appBootstrapper();
                        return;
                    } catch (e) {
                        if (e instanceof Error) {
                            if (e.message === "Widget App is not installed") {
                                showMessage(
                                    element,
                                    messageHtml,
                                    'Install <a href="https://store.office.com/en-us/app.aspx?assetid=WA104380769">Plumsail HelpDesk Widget add-in</a> to enable automatic sign-in under current SharePoint user.');
                                return;
                            }
                            else if (e.name ==="crosstenant") {
                                showMessage(
                                    element,
                                    messageHtml,
                                    e.message);
                                return;
                            }
                        } else {
                            console.info("SharePoint authentication failed ---", e);
                        }
                    }
                } else{
                    try {
                        await authService.IdentityAuthenticate();
                        console.info("Identity authentication succeeded");
                        appBootstrapper();
                        return;
                    } catch (e) {
                        console.info("Identity authentication failed ---", e);
                    }
                }

                    const loginView = new loginViewModel.LoginViewModel(element, authService, configService, localizationService);
                    loginView.Init();

                }) as any);
            });
        });
}


// WEBPACK FOOTER //
// ./Widget/app.ts